export default function NoteSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0F172A] via-[#0c2340] to-[#0F172A]">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden border border-cyan-500/30 bg-white/5 backdrop-blur-sm p-10 sm:p-14 flex flex-col lg:flex-row items-center gap-10">
          {/* 背景装飾 */}
          <div className="absolute top-0 right-0 w-72 h-72 bg-cyan-500/10 rounded-full blur-3xl pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-56 h-56 bg-amber-400/10 rounded-full blur-3xl pointer-events-none"></div>

          {/* 左：noteロゴ＋アイコン */}
          <div className="relative z-10 flex-shrink-0 flex flex-col items-center gap-4">
            <div className="w-24 h-24 flex items-center justify-center rounded-2xl bg-gradient-to-br from-[#41C9B4] to-[#0891B2] shadow-lg shadow-cyan-500/30">
              <i className="ri-article-line text-5xl text-white"></i>
            </div>
            <span className="text-white/60 text-sm font-medium tracking-widest uppercase">note</span>
          </div>

          {/* 右：テキスト＋ボタン */}
          <div className="relative z-10 flex-1 text-center lg:text-left">
            {/* バッジ */}
            <span className="inline-block mb-4 px-4 py-1 rounded-full bg-amber-400/20 text-amber-400 text-sm font-bold border border-amber-400/30">
              ブログ・お役立ち情報
            </span>

            {/* アカウント名 */}
            <p className="text-cyan-400 text-sm font-semibold mb-2 tracking-wide">
              サクッとHP｜AI × ホームページ制作
            </p>

            {/* 見出し */}
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 leading-snug">
              AI活用・Web集客の<br className="hidden sm:block" />
              <span className="text-amber-400">お役立ち情報</span>を発信中
            </h2>

            {/* 説明文 */}
            <p className="text-white/70 text-base leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              AI活用のコツや、Web集客のヒント、最新トレンドをnoteで発信中です。ぜひフォローしてください。
            </p>

            {/* ボタン */}
            <a
              href="https://note.com/ai_kaishainda"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-gradient-to-r from-[#0891B2] to-[#06b6d4] text-white font-bold text-base shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-article-line text-xl"></i>
              記事を読む
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
